import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Grid } from '@mui/material';
import { Box } from '@mui/material';

import FormView from '../../../../components/views/formView';
import { useRedirectPqrForm } from '../hook';
import { RedirectParamsData } from './data';
import { RedirectParamsHistorical } from '../historical';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isTrainerOrQuality } from '../../../../../shared/types/profiles';
import {
    REDIRECTEDIT,
    REDIRECTNEW,
    REDIRECTLIST,
    REDIRECT_DETAIL,
} from '../../../../../routes/paths';

export const RedirectPqrForm = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const {
        redirect,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setormikRedirectData,
        redirectHistorical,
    } = useRedirectPqrForm(showHistorical);

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons = redirect && redirect?.id ? true : false;

    return (
        <>
            <FormView
                title={
                    redirect && redirect.id
                        ? 'Editar persona redirección PQR'
                        : 'Crear persona redirección PQR'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={redirect?.id || ''}
                        buttonCreate={{
                            show:
                                showActionButtons && !isTrainerOrQuality(type),
                            route: REDIRECTNEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: REDIRECTLIST,
                        }}
                        buttonUpdate={{
                            show:
                                !showActionButtons && !isTrainerOrQuality(type),
                            route: REDIRECTEDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: REDIRECT_DETAIL,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <RedirectParamsHistorical
                        historical={redirectHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <RedirectParamsData
                data={redirect}
                onChangeFormik={(formik) => setormikRedirectData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
